import { Component } from "react";
import ToggleField from "../../../components/inputs/toggleField";
import InputField from "../../../components/inputs/inputField";
import SelectField from "../../../components/inputs/selectField";
import PagePreviewFrame from "../../../views/pages/components/pagePreviewFrame";
import FormSubmissionsModal from "./modals/formSubmissionsModal";

const ENV =
    process.env.NODE_ENV === "production"
        ? window.location.href.includes("planner.simple.events")
            ? `https://admin-api.simple.events/`
            : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;

class WalkinFormSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formSubmissionModalOpen: false,
        };
    }
    render() {
        const {
            checkInAppConfiguration,
            orgId,
            eventId,
            programId,
            walkInFormId,
            editCount,
            handleChange,
            formManager,
            account,
            event,
        } = this.props;
        const { formSubmissionModalOpen } = this.state;

        // Build form field options from the walk-in form for Salesforce lookup selects
        const walkInFormFields = {};
        if (checkInAppConfiguration.walkInForm?.pages) {
            checkInAppConfiguration.walkInForm.pages.forEach(page => {
                page.sections?.forEach(section => {
                    section.fields?.forEach(field => {
                        if (field?.nestedSections?.length > 0) {
                            field.nestedSections.forEach(nestedSection => {
                                nestedSection.questions?.forEach(nestedField => {
                                    if (nestedField.id) walkInFormFields[nestedField.id] = nestedField;
                                });
                            });
                        }
                        if (field.id) walkInFormFields[field.id] = field;
                    });
                });
            });
        }
        const formFieldOptions = Object.keys(walkInFormFields).map(key => ({
            label: walkInFormFields[key].label,
            value: walkInFormFields[key].id,
        }));

        return (
            <div className="sectionBody">
                <div className="blocksContainer">
                    <div className="flex w-100">
                        <div className="sectionBlock mr-25 contained-h">
                            <h2 className="blockHeader">Setup</h2>
                            <ToggleField
                                label="Use Checkin Form"
                                disabled={
                                    checkInAppConfiguration.enabled &&
                                    !checkInAppConfiguration.walkInForm
                                }
                                alert={
                                    checkInAppConfiguration.enabled &&
                                        !checkInAppConfiguration.walkInForm
                                        ? "App must be disabled to configure new walkin checkin form"
                                        : null
                                }
                                checked={checkInAppConfiguration.useCheckinFormForWalkIn}
                                onChange={(e) => {
                                    handleChange({ useCheckinFormForWalkIn: e.target.checked });
                                }}
                                icons={false}
                            />

                            {checkInAppConfiguration.useCheckinFormForWalkIn && !programId && (
                                <button
                                    className="neu"
                                    onClick={() =>
                                        this.setState({ formSubmissionModalOpen: true })
                                    }
                                >
                                    View Submissions
                                </button>)}

                            <h2 className="blockHeader mt-20">Salesforce Options</h2>
                            <ToggleField
                                label="Submit registrant as lead in campaign"
                                checked={checkInAppConfiguration.salesforceLeadEnabled || false}
                                icons={false}
                                disabled={!event?.integrations?.salesforce?.campaignName}
                                information={!event?.integrations?.salesforce?.campaignName ? "Please set up a Salesforce Campaign to enable this option." : false}
                                onChange={(e) => {
                                    handleChange({ salesforceLeadEnabled: e.target.checked });
                                }}
                            />
                            {checkInAppConfiguration.salesforceLeadEnabled && (
                                <div className="flex gap10">
                                    <InputField
                                        label="Custom Lookup Field"
                                        classes={"w-100"}
                                        type="text"
                                        name="customLookupField"
                                        information="Custom Field ID from Salesforce to use in query for existing lead or contact if email is not found."
                                        placeholder="Custom_Field__c"
                                        value={checkInAppConfiguration.salesforceCustomLeadQuery?.fieldName || ''}
                                        onChange={(e) => {
                                            handleChange({
                                                salesforceCustomLeadQuery: {
                                                    ...checkInAppConfiguration.salesforceCustomLeadQuery,
                                                    fieldName: e.target.value,
                                                },
                                            });
                                        }}
                                    />
                                    <SelectField
                                        label="Lookup Form Field"
                                        classes="w-100"
                                        information="Choose the field to pull the data from in form"
                                        placeholder="Form field"
                                        value={formFieldOptions.find(option => option.value === checkInAppConfiguration.salesforceCustomLeadQuery?.fieldId)}
                                        onChange={(e) => {
                                            handleChange({
                                                salesforceCustomLeadQuery: {
                                                    ...checkInAppConfiguration.salesforceCustomLeadQuery,
                                                    fieldId: e.value,
                                                },
                                            });
                                        }}
                                        options={formFieldOptions}
                                    />
                                </div>
                            )}
                            {checkInAppConfiguration.salesforceLeadEnabled && (
                                <div className="mt-20">
                                    <h2 className="blockHeader">New Lead Details</h2>
                                    <p className="small mb-10">Fields to populate on new Salesforce leads created from this walk-in registration.</p>
                                    {(checkInAppConfiguration.newLeadCustomFields || []).map((field, index) => (
                                        <div key={index} className="flex gap10 mb-10 flex-ac">
                                            <InputField
                                                label="Custom Field Name"
                                                classes={"w-100"}
                                                type="text"
                                                information="Custom Field ID from Salesforce to populate on new leads."
                                                placeholder="Custom_Field__c"
                                                value={field.fieldName || ''}
                                                onChange={(e) => {
                                                    const updatedFields = [...(checkInAppConfiguration.newLeadCustomFields || [])];
                                                    updatedFields[index] = { ...updatedFields[index], fieldName: e.target.value };
                                                    handleChange({ newLeadCustomFields: updatedFields });
                                                }}
                                            />
                                            <SelectField
                                                label="Form Field"
                                                classes="w-100"
                                                information="Choose the field to pull the data from in form"
                                                placeholder="Form field"
                                                value={formFieldOptions.find(option => option.value === field.fieldId)}
                                                onChange={(e) => {
                                                    const updatedFields = [...(checkInAppConfiguration.newLeadCustomFields || [])];
                                                    updatedFields[index] = { ...updatedFields[index], fieldId: e.value };
                                                    handleChange({ newLeadCustomFields: updatedFields });
                                                }}
                                                options={formFieldOptions}
                                            />
                                            <i
                                                className="las la-times c-pointer mt-20"
                                                style={{ fontSize: 20 }}
                                                onClick={() => {
                                                    const updatedFields = (checkInAppConfiguration.newLeadCustomFields || []).filter((_, i) => i !== index);
                                                    handleChange({ newLeadCustomFields: updatedFields });
                                                }}
                                            />
                                        </div>
                                    ))}
                                    {(() => {
                                        const fields = checkInAppConfiguration.newLeadCustomFields || [];
                                        const canAdd = fields.length === 0 || (fields[fields.length - 1].fieldName && fields[fields.length - 1].fieldId);
                                        return (
                                            <div
                                                className={`flex jcc mt-10 ${canAdd ? 'c-pointer' : 'disabled'}`}
                                                style={{ opacity: canAdd ? 1 : 0.4, cursor: canAdd ? 'pointer' : 'not-allowed' }}
                                                onClick={() => {
                                                    if (!canAdd) return;
                                                    const updatedFields = [...fields, { fieldName: '', fieldId: '' }];
                                                    handleChange({ newLeadCustomFields: updatedFields });
                                                }}
                                            >
                                                + Add Field
                                            </div>
                                        );
                                    })()}
                                </div>
                            )}
                        </div>
                        {!checkInAppConfiguration.useCheckinFormForWalkIn && (
                            <div
                                style={{ padding: 5, minWidth: 490 }}
                                className="sectionBlock contained-h emailDesignPreview mt-20 "
                            >
                                <div
                                    style={{
                                        width: 590,
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                    }}
                                    className="cardDetailsContainerPages containerTitle mb-20"
                                >
                                    <div className="w-100">
                                        <h2 className="blockHeader m-0">Form Builder</h2>
                                    </div>

                                    {!checkInAppConfiguration.walkInForm ? (
                                        <button
                                            className="neu ml-a"
                                            onClick={formManager.toggleFormEditorModal}
                                        >
                                            Add Form
                                        </button>
                                    ) : (
                                        <div className="flex aic ml-a">
                                            {!programId && <button
                                                className="neu mr-10"
                                                onClick={() =>
                                                    this.setState({ formSubmissionModalOpen: true })
                                                }
                                            >
                                                View Submissions
                                            </button>}

                                            <button
                                                className="neu prim"
                                                onClick={formManager.toggleFormEditorModal}
                                            >
                                                Edit Form
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div
                                    style={{
                                        width: 590,
                                        maxWidth: "calc(100% - 15px)",
                                        minWidth: "calc(100% - 700px)",
                                        height: 500,
                                    }}
                                >
                                    <div className="emailPreview eFrame pages flex-ac preview">
                                        {walkInFormId ? (
                                            <PagePreviewFrame
                                                ENV={ENV}
                                                key={`walkin-${editCount}`}
                                                renderURL={!programId ? `Organizations/${orgId}/events/${eventId}/pages/render/formRender/` : `Organizations/${orgId}/programs/${programId}/render/walkInForm/`}
                                                pageProperties={{}}
                                                focusedComponent={""}
                                                simulatedUser={{ value: account._id }}
                                                simulatedSession={{ value: false }}
                                                renderOnly={true}
                                                formId={walkInFormId}
                                                preview={true}
                                            />
                                        ) : (
                                            <div className="flex column aic jcc w-100">
                                                <h3>Add a form to get started</h3>
                                                <p>A preview will show here.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {formSubmissionModalOpen && <FormSubmissionsModal
                    key={'walkinFormSubmissions'}
                    isOpen={formSubmissionModalOpen}
                    toggle={() => this.setState({ formSubmissionModalOpen: false })}
                    form={!checkInAppConfiguration.useCheckinFormForWalkIn ? checkInAppConfiguration.walkInForm : checkInAppConfiguration.checkInForm}
                    formType={"walkInForm"}
                    orgId={this.props.orgId}
                    eventId={this.props.eventId}
                    event={this.props.event}
                    documentSigningEnabled={checkInAppConfiguration.documentSigningConfig?.enabled}
                />}
            </div>
        );
    }
}

export default WalkinFormSetup;
